import { getAnchorFromEvent, isExternalUrl } from './anchorLinks';

/**
 * Routes an anchor click to the host so the link leaves the reader iframe.
 *
 * With `nativeLinks`, an anchor marked `data-native-link` is left to the browser.
 * Routing it would trade the visitor's tap for a `window.open()` the host makes on
 * its own behalf a bridge round-trip later, and iOS keeps its store and app
 * hand-offs for navigations the visitor starts: the App Store badge did nothing in
 * Safari on the iPhone while it worked in Chrome. The iframe's `allow-popups`
 * sandbox lets the link open its own tab.
 *
 * The marker is deliberate rather than keying on `target="_blank"`: Smart Zoom
 * stamps `_blank` on every article link and the WeChat share anchor carries it too,
 * and both want the host's window, which is not bound by the iframe's sandbox.
 * Only the web host may opt in at all: the Fenice WebViews open no windows, so a
 * link left alone there would load over the reader itself.
 */
const handleUrl = (event, openUrlCallback, { nativeLinks = false } = {}) => {
    const anchor = getAnchorFromEvent(event);
    if (nativeLinks && isNativeLink(anchor)) return;

    const url = anchor?.href;
    if (!isExternalUrl(url)) return;

    openUrlCallback(url);
    event.stopPropagation();
    event.preventDefault();
};

const isNativeLink = anchor => anchor?.dataset?.nativeLink !== undefined;

export default handleUrl;
